<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="menuData != ''">
            <div class="container-fluid xyz">
                <div class="admin-page-content">
                    <div class="internal-container">
                        <div class="bullentin-questin-answer">
                            <div class="questions">{{postData.title}}</div>
                            <div class="answers">
                                <span v-html="postData.description" v-linkified:options="{ className: '' }"></span>
                                <div class="clearfix"></div>
                                <div class="bullentintext">
                                    <template v-if='postData.documents.length > 0'>
                                        <h5>Corresponding Files</h5>
                                        <div class="attachmentContainer">
                                            <template>
                                                <swiper class="" :options="swiperOptionAttachments" ref="mySwiper">
                                                    <template v-for="(doc, index1) in postData.documents">
                                                        <template v-if="doc.doc_extension.toLowerCase() == 'gif' || doc.doc_extension.toLowerCase() == 'jpg' || doc.doc_extension.toLowerCase() == 'jpeg' || doc.doc_extension.toLowerCase() == 'png'">
                                                            <swiper-slide>
                                                                <img :src="doc.document" @click="openGallery(postData.documents,index1)">
                                                            </swiper-slide>
                                                        </template>
                                                        <template v-else-if="doc.doc_extension.toLowerCase() == 'doc' || doc.doc_extension.toLowerCase() == 'docx'">
                                                            <swiper-slide>
                                                                <a :href="doc.document" target="_blank"><img src="/static/images/doc-icon.png" class="link-icon"></a>
                                                            </swiper-slide>
                                                        </template>
                                                        <template v-else-if="doc.doc_extension.toLowerCase() == 'xls' || doc.doc_extension.toLowerCase() == 'xlsx'">
                                                            <swiper-slide>
                                                                <a :href="doc.document" target="_blank"><img src="/static/images/xl-icon.png" class="link-icon"></a>
                                                            </swiper-slide>
                                                        </template>
                                                        <template v-else-if="doc.doc_extension.toLowerCase() == 'ppt' || doc.doc_extension.toLowerCase() == 'pptx'">
                                                            <swiper-slide>
                                                                <a :href="doc.document" target="_blank"><img src="/static/images/ppt-icon.png" class="link-icon"></a>
                                                            </swiper-slide>
                                                        </template>
                                                        <template v-else-if="doc.doc_extension.toLowerCase() == 'pdf'">
                                                            <swiper-slide>
                                                                <a :href="doc.document" target="_blank"><img src="/static/images/pdf-icon.png" class="link-icon"></a>
                                                            </swiper-slide>
                                                        </template>
                                                        <template v-else>
                                                            <swiper-slide>
                                                                <a :href="doc.document" target="_blank"><img src="/static/images/link-icon.png" class="link-icon"></a>
                                                            </swiper-slide>
                                                        </template>
                                                    </template>
                                                </swiper>
                                            </template>
                                        </div>
                                        <!--<div class="attachmentContainer">
                                            <template v-for="(doc, index1) in postData.documents">
                                                <template v-if="doc.doc_extension.toLowerCase() == 'gif' || doc.doc_extension.toLowerCase() == 'jpg' || doc.doc_extension.toLowerCase() == 'jpeg' || doc.doc_extension.toLowerCase() == 'png'">
                                                    <img :src="doc.document" @click="openGallery(postData.documents,index1)">
                                                </template>
                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'doc' || doc.doc_extension.toLowerCase() == 'docx'">
                                                    <a :href="doc.document" target="_blank"><img src="/static/images/doc-icon.png" class="link-icon"></a>
                                                </template>
                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'xls' || doc.doc_extension.toLowerCase() == 'xlsx'">
                                                    <a :href="doc.document" target="_blank"><img src="/static/images/xl-icon.png" class="link-icon"></a>
                                                </template>
                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'ppt' || doc.doc_extension.toLowerCase() == 'pptx'">
                                                    <a :href="doc.document" target="_blank"><img src="/static/images/ppt-icon.png" class="link-icon"></a>
                                                </template>
                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'pdf'">
                                                    <a :href="doc.document" target="_blank"><img src="/static/images/pdf-icon.png" class="link-icon"></a>
                                                </template>
                                                <template v-else>
                                                    <a :href="doc.document" target="_blank"><img src="/static/images/link-icon.png" class="link-icon"></a>
                                                </template>
                                            </template>
                                        </div>-->
                                    </template>
                                </div>
                            </div>

                        </div>
                        <!--<div class="bulletin-board-listing">
                            <div class="comment-section full-comment-section">
                                <div class="avtarimg">
                                    <img src="/static/images/default.jpg">
                                </div>
                                <div class="comment-textarea">
                                    <textarea placeholder="Add a Comment..."></textarea>
                                    <a href="#" class="commentbtn">Comment</a>
                                </div>
                            </div>
                        </div>-->
                        <!--<div class="bulletin-board-listing bulletin-board-listing-details">
                            <div class="bulletin-view">
                                <div class="avtarimg">
                                    <img src="/static/images/default.jpg">
                                </div>
                                <div class="bulletin-view-details">
                                    <div class="bullentin-internal-details">
                                        <div class="useravtarname">Gaurav Deshmukh</div>
                                        <div class="bullentininfo">20 January, 2019 &nbsp; | &nbsp;4:30 PM</div>
                                    </div>
                                    <div class="bullentin-board-listing-top">
                                        <div class="vote-count">
                                            <img src="/static/images/vote-count.png">
                                            Upvote  23
                                        </div>
                                        <div class="bullentin-comments-count">
                                            <img src="/static/images/comments-icon.png">
                                            Comment  (8)
                                        </div>
                                        <div class="commentsview">25 Views</div>
                                    </div>
                                    <div class="bullentintext">
                                        VPOD is Variable Pressure Output Device. During engine EGR (Exhaust Gas Recirculation) operation, the VPOD provides modulated air pressure to the pneumatic actuators which change the VNT (Variable Nozzle Turbine) vanes and EGR valve positions.<br/><br/>

                                        VNTs, (also known as Variable-geometry turbochargers (VGTs), are a family of turbochargers, usually designed to allow the effective aspect ratio (A:R) of the turbo to be altered as conditions change. This is done because optimum aspect ratio at low engine speeds is very different from that at high engine speeds. If the aspect ratio is too large, the turbo will fail to create boost at low speeds; if the aspect ratio is too small, the turbo will choke the engine at high speeds, leading to high exhaust manifold pressures, high pumping losses, and ultimately lower power output.
                                        By altering the geometry of the turbine housing as the engine accelerates, the turbo's aspect ratio can be maintained at its optimum.<br/><br/>

                                        These alterations are achieved by VPOD.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bulletin-board-listing bulletin-board-listing-details">
                            <div class="bulletin-view">
                                <div class="avtarimg">
                                    <img src="/static/images/default.jpg">
                                </div>
                                <div class="bulletin-view-details">
                                    <div class="bullentin-internal-details">
                                        <div class="useravtarname">Colton Baron</div>
                                        <div class="bullentininfo">20 January, 2019 &nbsp; | &nbsp;4:30 PM</div>
                                    </div>
                                    <div class="bullentin-board-listing-top">
                                        <div class="vote-count">
                                            <img src="/static/images/vote-count.png">
                                            Upvote  23
                                        </div>
                                        <div class="bullentin-comments-count">
                                            <img src="/static/images/comments-icon.png">
                                            Comment  (8)
                                        </div>
                                        <div class="commentsview">25 Views</div>
                                    </div>
                                    <div class="bullentintext">
                                        Vpod. Variable pressure output device. Part of the EGR system. Exhaust gas recirculation. Helps cut emissions.
                                    </div>
                                </div>
                            </div>
                        </div>-->
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            We are Sorry!
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>
    var exten = ['gif', 'jpg', 'jpeg', 'png'];
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import {commonMixins} from '../mixins/commonMixins';
    import {HTTP} from '../http-common.js';
    import { Button } from 'bootstrap-vue/es/components';

    /* Swiper for submenu tebs start */
    import 'swiper/dist/css/swiper.css';
    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    /* Swiper for submenu tebs end */

    Vue.component("app-footer", Footer);
    export default {
        name: 'CommonPage',
        components: {
            swiper,
            swiperSlide,
        },
        mixins: [commonMixins],
        data() {
            return {
                swiperOptionAttachments: {
                    slidesPerView: 14.5,
                    spaceBetween: 8,
                    freeMode: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    breakpoints: {
                        1500: {
                            slidesPerView: 12.5
                        },
                        1400: {
                            slidesPerView: 11.4
                        },
                        1300: {
                            slidesPerView: 10.4
                        },
                        1200: {
                            slidesPerView: 9.5
                        },
                        1000: {
                            slidesPerView: 9.5
                        },
                        667: {
                            slidesPerView: 7.5
                        },
                        480: {
                            slidesPerView: 5.5
                        },
                        360: {
                            slidesPerView: 4.5
                        }
                    }
                },

                postData: {
                    documents: [],
                    postId: [],
                },
                lightboxImages: [],
            }
        },
        created: function () {

        },
        beforeMount: function () {
            var self = this;
        },
        mounted: function () {
            var self = this;
            self.postId = localStorage.getItem('post_id');
            self.getMenuSlug();
        },

        methods: {
            //common call methods to get slug and change route in watch and mounted method.
            getMenuSlug: function () {
                var self = this;
                self.menuSlug = this.$route.params.type;
                self.getMenuDetails(self.menuSlug);
                self.loadSalesData();
            },

            loadSalesData: function () {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    params: {'slug': self.menuSlug, id: self.postId}
                };
                self.showLoader();
                HTTP.get("display_sales_details", config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.postData = response.data.content;
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            /* Display Sales Data End*/
            /* display user name in formated string */
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            /*get user's initials from firstname lastname */
            getInitials: function (string) {
                var names = string.split(' ');
                var initials = "";
                $.each(names, function (i) {
                    initials += names[i].charAt(0);
                });
                return initials.toUpperCase();
            },
            /* Get images for gallery view */
            openGallery: function (documents, index) {
                var self = this;
                var arr = [];
                var new_index = 0;
                $.each(documents, function (i) {
                    if (jQuery.inArray(documents[i].doc_extension.toLowerCase(), exten) !== -1) {
                        if (i == index) {
                            index = new_index;
                        }
                        arr.push({
                            'thumb': documents[i].document,
                            'src': documents[i].document,
                            'caption': '',
                        });
                        new_index = new_index + 1;
                    }
                });
                /* self.loadImagesInLightBox(arr, index); */
            },
            /* set images to gallery view */
            /* loadImagesInLightBox: function (arr, index) {
             var self = this;
             self.lightboxImages = arr;
             this.$refs.lightbox.showImage(index);
             }, */
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/CommonPostDetail.vue